var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.data.groups),function(group){return _c('div',[_c('i',{staticClass:"fa fa-user",attrs:{"aria-hidden":"true"}}),_vm._v("\n\n    "+_vm._s(group.name)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }